export const environment = {
  production: true,
  api: {
    // Do not use "/" at the end of the URL
    baseUrl: 'https://auh-healthcare.dev.viuto-aiot.com',
    publicKey: 'MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAzCqxzKRNKlVzFXWuEM2V84+MB9zxnv9nKGyaX7WP3LOC2AhoU4+2eun9Sp7fEzl3E193Hj2LQACV/BgMneObg2vB8LYaYB3F/Ezdt+FYSqwkNrx2OD7+qliSvYYM734+urBhpkGhgOEWYGlpY5kMH474TM6t689rEoVsOPGUxKPbMWZE/BL3bKu4DW/Is20n//UialzmpvlGZIQJ+SIaL3m+mnqYnEBOttTi9eL3KUAhOB9kCpySmV6ytcsk/tjPBJhGlv9y8mavL+4U9yuWGLZIwmS/QG7IwxLan18gmhRWkP2h0ywkyHJBzlzd2HkW6FKNiN+65t/TURbTT5FWfQIDAQAB',
  },
  constant: {
    siteName: 'We Care 智慧健康科技照護平台',
    hospitalName: '亞洲大學附屬醫院',
    contact: {
      phone: '(04)2332-9888#1075',
      email: 'asiaprevention@gmail.com',
    },
  },
};
